<template>


  <div>
    <InfoPanel v-model:is-open="infoPanelIsOpen" :current-item="infoPanelCurrentItem" @item-used="refreshView"/>

    <br>
    <div style="display: flex;">
      <div style="width:40%;margin:auto;">
        <button @click="enterShop()" class="back-to-shop-button" :disabled="isBlocked">
          Shop
        </button>
      </div>

      <br>

      <div style="width:40%;margin:auto;">
        <button @click="enterBattleCoinShop()" class="back-to-shop-button" :disabled="isBlocked">
          Battle Coin Shop
        </button>
      </div>

      
<!--      <div style="width:40%;margin:auto;">-->
<!--        <button @click="enterRanking()" class="back-to-shop-button" :disabled="isBlocked">-->
<!--          Ranking-->
<!--        </button>-->
<!--      </div>-->
    </div>

    <div class="container">
      <div style="padding-top:10px;">
        <div v-if="showDailyRewardMessage" style="text-align: center;padding:10px; border: 2px solid;">
          <p>{{ translation.general.dailyReward }}</p>
          <p>

            <a href="https://discord.gg/cT3ThCj" target="_blank" class="pcg-whitelist__url">
              https://discord.gg/cT3ThCj
            </a>
          </p>
        </div>
      </div>
      <h5 class="item-list__title">
        ${{ cash }} - {{ translation.itemList.yourItems }}:
      </h5>
      <div class="row p-2">
        <div class="col-3 itemn-list__entry" v-for="item in allItems" :key="item.id">
          <ItemEntryButton :id="item.id" :name="item.name" :sprite_name="item.sprite_name" :amount="item.amount"
                           @click="openInfoPanel(item)"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {translation} from "@/utils/translations";
import {backendUri} from "@/utils/settings";

import {ref} from "@vue/reactivity";
import {onMounted} from "@vue/runtime-core";
import InfoPanel from "./InfoPanel";
import {startLoadingProcess, stopLoadingProcess} from "@/components/LoadingOverlay/loadingOverlayControl";
import ItemEntryButton from "@/components/ItemEntryButton/ItemEntryButton";
import {handleUnknownError} from "@/utils/utilities";
import ItemShop from "./ItemShop";
import {currentView} from "../../utils/globals";
import {blockButton, isBlocked, unblockButton} from "../../components/ButtonControl/ButtonControl";
import BattleItemShop from "./BattleItemShop";


export default {
  name: 'ItemList',
  components: {
    InfoPanel,
    ItemEntryButton,
  },
  setup() {
    const allItems = ref([]);
    const cash = ref([]);

    const infoPanelIsOpen = ref(false);
    const showDailyRewardMessage = ref(false);
    const infoPanelCurrentItem = ref({});
    const openInfoPanel = async (item) => {
      infoPanelIsOpen.value = true;
      infoPanelCurrentItem.value = {
        ...item,
        ...item
      };
    }

    const enterShop = async () => {
      blockButton();
      currentView.value = ItemShop;
    }

    const enterBattleCoinShop = async () => {
      blockButton();
      currentView.value = BattleItemShop;
    }


    const refreshView = async () => {
      startLoadingProcess();
      infoPanelIsOpen.value = false;
      await axios.get(backendUri + "api/game/ext/trainer/inventory/")
          .then((resp) => {
            allItems.value = resp.data.allItems;
            cash.value = resp.data.cash;
            showDailyRewardMessage.value = resp.data.show_daily_reward_message;
          })
          .catch(error => {
            handleUnknownError(error);
          })
      stopLoadingProcess();
    }

    onMounted(() => {
      refreshView();
      setTimeout(function () {
        unblockButton();
      }, 3000);
    });


    return {
      translation,
      refreshView,
      openInfoPanel,
      allItems,
      infoPanelIsOpen,
      infoPanelCurrentItem,
      cash,
      showDailyRewardMessage,
      enterShop,
      isBlocked,
      enterBattleCoinShop
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables';

.item-list {
  &__title {
    padding-top: 20px;
    margin-left: 8px;
  }

  &__entry {
    padding: 0;
    margin-bottom: 20px;
  }
}

.pcg-whitelist {
  background-color: $poketwitch-branding-color;
  color: white;
  font-family: "Josefin Sans", sans-serif;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;

  &__url {
    color: white;
    transition: all .3s;
    background: #9f3e3e;
    padding: 10px;
    border-radius: 3px;

    &:hover {
      background: #c62b2b;
      box-shadow: #c62b2b 0 0 10px;
      text-decoration: none;
    }
  }
}

.back-to-shop-button {
  width: 100%;
  margin: auto;
  border-radius: 55px;
  background-color: #007bff;
  border-color: black;
  color: white;

  &:disabled {
    opacity: 0.2;
  }

  &:hover {
    transform: scale(1.1);
  }
}

</style>


